<template>
  <div id="loginform" v-if="!pageload">
    <form>
      <h2>{{ $t("messages.login.title") }}</h2>
      <div class="form-group">
        <label>{{ $t("messages.general.username") }}</label>
        <input
          @keyup.enter="login"
          type="text"
          class="form-control"
          v-model="username"
        />
      </div>
      <div class="form-group">
        <label>{{ $t("messages.general.password") }}</label>
        <input
          @keyup.enter="login"
          type="password"
          class="form-control"
          v-model="password"
        />
      </div>
      <div class="alert alert-danger" role="alert" v-if="isHasError">
        {{ msg }}
      </div>
      <button type="button" @click="login()" class="btn btn-primary">
        {{ $t("messages.login.title") }}
      </button>
      <hr />
      Copyright © 2019 Mae Fah Luang University
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import UserProvider from "@/services/user_provider";
import MasterDataProvider from "@/services/masterData_provider";
import { Base64 } from "js-base64";

const userProvider = new UserProvider();
const masterDataProvider = new MasterDataProvider();

export default {
  name: "Login",
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      isRedirectStatement: "isRedirectStatement"
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    }
  },
  data: () => {
    return {
      username: "",
      password: "",
      isHasError: false,
      msg: "",
      pageload: true
    };
  },
  methods: {
    ...mapActions("application", [
      "togglePreLoader",
      "initApplication",
      "setToken",
      "setMenu",
      "setCurrentUserAsync",
      "setSessionGuid",
      "setSeq",
      "clearToken",
      "setCurrentUser",
      "switchTheme",
      "setRedirectPage"
    ]),
    getUserId: function(token) {
      let userinfo = JSON.parse(atob(token.split(".")[1])).user_claims.data;

      if (userinfo.usertype === 10) {
        return userinfo.userid;
      }
      return userinfo.misuserid;
    },
    login() {
      const router = this.$router;
      const self = this;
      if (self.username === "") {
        self.isHasError = true;
        self.msg = this.$t("messages.login.validateUser");
        return;
      }
      if (self.password === "") {
        self.isHasError = true;
        self.msg = this.$t("messages.login.validatePwd");
        return;
      }

      this.togglePreLoader(true);
      this.setRedirectPage("");
      userProvider
        .login({
          username: Base64.encode(this.username),
          password: Base64.encode(this.password)
        })
        .then(response => {
          if (typeof response === "undefined") {
            self.isHasError = true;
            self.msg = this.$t("messages.login.userPassWrong");
            this.togglePreLoader(false);
          } else {
            if (response.status == 500) {
              self.isHasError = true;
              self.msg =
                response && response != undefined
                  ? response.data.msg != undefined
                    ? `${response.status}: ${response.data.msg}`
                    : `${response.status}: ${response.data}`
                  : response.message;
              this.togglePreLoader(false);
              return;
            }
            this.pageload = true;
            const token = response.token;
            this.setToken(response.token);

            const userid = this.getUserId(token);
            masterDataProvider
              .getMenu({
                token: token,
                userId: userid,
                lang: this.currentLang
              })
              .then(data => {
                this.setMenu(data);
                self.isHasError = false;
                this.initApplication();
                if (userid !== undefined) {
                  this.setCurrentUserAsync({
                    token: token,
                    request: {
                      userid: userid,
                      lang: this.currentLang
                    }
                  }).then(() => {
                    this.togglePreLoader(false);
                    let redirect =
                      self.$route.query.redirect !== undefined
                        ? self.$route.query.redirect
                        : "/";
                    router.push(redirect);
                  });
                }
              });
          }
        })
        .catch(error => {
          this.togglePreLoader(false);
          this.pageload = false;
          self.isHasError = true;
          console.log(error);
          self.msg =
            error.response && error.response != undefined
              ? error.response.data
              : error.message;
        });
    }
  },
  mounted() {
    // debugger
    this.switchTheme(0);
    if (
      typeof this.$route.query.session_guid !== "undefined" ||
      typeof this.$route.query.sessionguid !== "undefined"
    ) {
      const self = this;
      const router = this.$router;
      const sessionId =
        typeof this.$route.query.session_guid !== "undefined"
          ? this.$route.query.session_guid
          : typeof this.$route.query.sessionguid !== "undefined"
          ? this.$route.query.sessionguid
          : "";
      const seq =
        typeof this.$route.query.seq !== "undefined"
          ? this.$route.query.seq
          : "";
      if (sessionId == "") {
        this.clearToken();
        this.$router.push("/redirecthome");
        // return;
      }

      if (sessionId == "firebase") {
        this.pageload = false;
        this.togglePreLoader(false);
        this.setToken(false);
        return;
      }

      const redirectPage =
        typeof this.$route.query.page !== "undefined"
          ? this.$route.query.page
          : "";

      this.setToken(false);
      this.setCurrentUser(false);
      this.setSessionGuid(sessionId);
      this.setSeq(seq);
      this.setMenu(false);
      this.setRedirectPage(redirectPage);
      this.$http
        .get(
          `${process.env.VUE_APP_API_ENDPOINT}reg/ee/authen?lang=TH&session_id=${sessionId}`
        )
        .then(res => {
          if (res.status === 200) {
            const token = res.data.token;
            this.setToken(res.data.token);

            const userid = this.getUserId(token);
            masterDataProvider
              .getMenu({
                token: token,
                userId: userid,
                lang: this.currentLang
              })
              .then(data => {
                this.setMenu(data);
                self.isHasError = false;
                this.initApplication();
                if (userid !== undefined) {
                  this.setCurrentUserAsync({
                    token: token,
                    request: {
                      userid: userid,
                      lang: this.currentLang
                    }
                  }).then(() => {
                    this.togglePreLoader(false);
                    let redirect =
                      self.$route.query.redirect !== undefined
                        ? self.$route.query.redirect
                        : "/";
                    if (this.isRedirectStatement) {
                      router.push("/printStatement");
                    } else {
                      router.push(redirect);
                    }
                  });
                }
              });
          } else if (res.status === 401) {
            this.setToken(false);
            this.setSessionGuid(false);
            this.setMenu(false);
            this.setSessionGuid(false);
            this.setMenu(false);
            router.push("/redirecthome");
          } else {
            return res;
          }
        })
        .catch(e => {
          if (e.response.status === 401) {
            this.setToken(false);
            this.setSessionGuid(false);
            this.setMenu(false);
            // router.push("/login");
            this.$router.push("/redirecthome");
          } else {
            return e.response.data;
          }
        });
    } else {
      this.$router.push("/redirecthome");
    }
    // else {
    //   this.pageload = false;
    //   this.togglePreLoader(false);
    //   this.setToken(false);
    //   this.setRedirectPage("");
    // }
  }
};
</script>

<style scoped>
form {
  margin-top: 15px;
  width: 240px;
}
#loginform {
  margin: auto;
  width: 300px;
  border: 1px solid lightgrey;
  padding: 30px;
}
</style>
